import { createSelector } from '@reduxjs/toolkit';

const selectGeofenceItems = (state) => state.geofences.items;

export const selectGeofencesOnly = createSelector(
  [selectGeofenceItems],
  (items) => Object.values(items).filter((g) => !g.attributes?.poi)
);

export const selectGeofencesMap = createSelector(
  [selectGeofenceItems],
  (items) => Object.fromEntries(
    Object.entries(items).filter(([, g]) => !g.attributes?.poi)
  )
);

// ── POIs (from Supabase poisSlice, NOT geofencesSlice) ──
const selectPOIItems = (state) => state.pois.items;
const selectPOICategoryItems = (state) => state.pois.categories;

export const selectPOIs = createSelector(
  [selectPOIItems],
  (items) => Object.values(items)
);

export const selectPOIsMap = createSelector(
  [selectPOIItems],
  (items) => items
);

export const selectPOICategories = createSelector(
  [selectPOICategoryItems],
  (categories) => Object.values(categories)
);

export const selectPOICategoriesMap = createSelector(
  [selectPOICategoryItems],
  (categories) => categories
);
